import React, { useState } from 'react';
import './Footer.css';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = () => {
    if (email) {
      console.log('Email submitted:', email);
      setEmail('');
    }
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="footer">
      <div className="footer-container">

        <div>
        {/* Newsletter Section */}
        <div className="newsletter-section">
          <h2 className="newsletter-title">Subscribe to our newsletter</h2>
          <div className="newsletter-form">
            <input
              type="email"
              placeholder="your@email.ru"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
              className="newsletter-input"
            />
            <button onClick={handleSubmit} className="newsletter-button">
              <span className="arrow">→</span>
            </button>
          </div>
        </div>

          {/* Social Icons */}
        <div className="social-section">
          <button className="scroll-top-button" onClick={scrollToTop} aria-label="Scroll to top">
            <span className="arrow-up">↑</span>
          </button>
          <a href="#facebook" className="social-icon" aria-label="Facebook">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </a>
          <a href="#youtube" className="social-icon" aria-label="YouTube">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
              <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="m9.75 15.02 5.75-3.27-5.75-3.27v6.54z" fill="currentColor"/>
            </svg>
          </a>
        </div>
        </div>
<div>
        {/* Top Navigation */}
        <nav className="top-nav">
          <a href="#blog" className="nav-link">Blog</a>
          <span className="nav-divider">/</span>
          <a href="#tutorials" className="nav-link">Tutorials</a>
          <span className="nav-divider">/</span>
          <a href="#webinar" className="nav-link">Webinar</a>
          <span className="nav-divider">/</span>
          <a href="#privacy" className="nav-link">Privacy Policy</a>
          <span className="nav-divider">/</span>
          <a href="#terms" className="nav-link">Terms & Conditions</a>
          <span className="nav-divider">/</span>
          <a href="#gdpr" className="nav-link">GDPR</a>
          <span className="nav-divider">/</span>
          <a href="#accessibility" className="nav-link">Accessibility</a>
        </nav>

        {/* Footer Links Grid */}
        <div className="footer-grid">
          {/* Info Column */}
          <div className="footer-column">
            <h3 className="column-title">INFO</h3>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#courses">Courses</a></li>
              <li><a href="#pricing">Pricing</a></li>
              <li><a href="#help">Help Center</a></li>
            </ul>
          </div>

          {/* Additional Column 1 */}
          <div className="footer-column">
            <h3 className="column-title">ADDITIONAL</h3>
            <ul className="footer-links">
              <li><a href="#documentation">Documentation</a></li>
              <li><a href="#api">API Reference</a></li>
              <li><a href="#blog">Blog</a></li>
              <li><a href="#tutorials">Tutorials</a></li>
            </ul>
          </div>

          {/* Additional Column 2 */}
          <div className="footer-column">
            <h3 className="column-title">ADDITIONAL</h3>
            <ul className="footer-links">
              <li><a href="#integration">Integration</a></li>
              <li><a href="#integration-detail">Integration Detail</a></li>
              <li><a href="#signup">Sign Up</a></li>
            </ul>
          </div>
        </div>

        {/* Contact Information */}
        <div className="contact-section">
          <div className="contact-item">
            <span className="contact-label">SELECTION COMMITTEE</span>
            <a href="tel:+15551234567" className="contact-value">+1 (555) 123-4567</a>
          </div>
          <div className="contact-item">
            <span className="contact-label">ADD. EDUCATION</span>
            <a href="tel:+18919891193" className="contact-value">+1 891 989-11-93</a>
          </div>
          <div className="contact-item">
            <span className="contact-label">EMAIL</span>
            <a href="mailto:hello@miles-lxp.com" className="contact-value">hello@miles-lxp.com</a>
          </div>
        </div>

        {/* Address */}
        <div className="address-section">
          <span className="address-label">ADDRESS</span>
          <p className="address-value">123 Innovation Drive, San Francisco, CA 94102</p>
        </div>

  </div>
      
      </div>

      {/* Copyright Bar */}
      <div className="copyright-bar">
        <p className="copyright-text">©2024 Mile LXP. All rights reserved.</p>
        <div className="language-selector">
          <button className="lang-button active">EN</button>
          <button className="lang-button">SE</button>
          <button className="lang-button">DE</button>
        </div>
      </div>
    </div>
  );
};

export default Footer;